export interface OrgUnits {
    orgUnitIds: string[]
}

export interface Positions {
    positions: string[]
}

export interface CostCenters {
    costCenters: string[]
    types: string[]
}

export interface EmployeeContracts {
    types: string[]
    subTypes: string[]
}

export interface FilterGroup {
    orgUnits: OrgUnits | null
    positions: Positions | null
    costCenters: CostCenters | null
    contracts: EmployeeContracts | null
    genders: string[] | null
}

export interface Dependencies {
    filterGroups: FilterGroup[]
    includedEmployees: string[] | null
    excludedEmployees: string[] | null
}

export class DependenciesFactory {
    static create(): Dependencies {
        return {
            filterGroups: [],
            includedEmployees: null,
            excludedEmployees: null,
        }
    }
}
